/** @jsxImportSource @emotion/react */
"use client";

import { useTranslations } from "@i18n/react";
import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import { matchSelectableGuide, useCurrentGuide } from "@packages/media";
import { ModalTab, ProfileIcon } from "@packages/ui";
import { HallowDataTestId } from "@tools/playwright/global";

import { useMediaAnalyticsProps } from "../../../../hooks/useMediaAnalyticsProps";
import type { MediaMenuTabProps } from "../MediaMenu.emotion";

export const SelectGuideTab = ({ disabled }: MediaMenuTabProps) => {
  const t = useTranslations();
  const { currentItem, guides } = useCurrentGuide();
  const { track } = useAnalytics();
  const analyticsProps = useMediaAnalyticsProps();

  return (
    <ModalTab
      key={"guideSelectMenuTab"}
      value={"guideSelectMenu"}
      data-testid={HallowDataTestId.MediaSettingsTab}
      label={t("track_settings_guide")}
      startIcon={<ProfileIcon />}
      disabled={disabled}
      onClick={() =>
        track({
          event: HallowAnalyticsEvent.TappedGuide,
          properties: analyticsProps,
        })
      }
    >
      {guides.find((g) =>
        matchSelectableGuide(g.guide_ids, currentItem.selected_audio.guide_ids),
      )?.name ?? t("general_word_error")}
    </ModalTab>
  );
};
